import React from 'react';
import {Trans} from 'react-i18next';
import TechnicalSupport from './technicalsupport';
import AccountPortlet from '../../../generalsettings/accountsettings/updateaccount/components/AccountPortlet';

export default function TechnicalSupportPortlet() {
  return (
    <AccountPortlet
      title={
        <Trans i18nKey="p.g.a.updateaccount.technical.support">
          Enable Technical Support Access
        </Trans>
      }
      titleDesc={
        <Trans i18nKey="p.g.a.updateaccount.technical.support.desc">
          Enable Technical Support team access from PerfectCorp to assist and
          troubleshoot your problems. You can remove their access anytime.
        </Trans>
      }
      body={
        <div className="kt-portlet kt-portlet--mobile kt-portlet--bordered kt-margin-b-20">
          <div className="kt-portlet__body">
            <TechnicalSupport />
          </div>
        </div>
      }
    />
  );
}
